// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a48037fa","239":"2050796f","453":"b2eec619","732":"3f78099e"}[chunkId] + ".chunk.js";
};